export const PQRS_NODE = 'pqrs_node';
export const OTHER_NODE = 'other_node';
export const PROCESS_NODE = 'process_node';